import apiTamboUrl from "@/services/api";

export default {
  namespaced: true,

  state: {
    ventas: [],
    compras: [],
    saldoTecnico: null,
    loading: false,
    loadingSaldo: false,
    error: null,
  },

  getters: {
    ventas: (s) => s.ventas,
    compras: (s) => s.compras,
    saldoTecnico: (s) => s.saldoTecnico,
    loading: (s) => s.loading,
    loadingSaldo: (s) => s.loadingSaldo,
    error: (s) => s.error,
  },

  mutations: {
    setVentas(state, data) {
      state.ventas = data;
    },
    setCompras(state, data) {
      state.compras = data;
    },
    setSaldoTecnico(state, data) {
      state.saldoTecnico = data;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setLoadingSaldo(state, val) {
      state.loadingSaldo = val;
    },
    setError(state, val) {
      state.error = val;
    },
    clearState(state) {
      state.ventas = [];
      state.compras = [];
      state.saldoTecnico = null;
      state.loading = false;
      state.loadingSaldo = false;
      state.error = null;
    },
  },

  actions: {
    async fetchVentas({ commit }, periodo) {
      commit("setLoading", true);
      commit("setError", null);
      try {
        const res = await apiTamboUrl.get(
          `/libro-iva/ventas?periodo=${periodo}`
        );
        commit("setVentas", res.data);
      } catch (e) {
        commit(
          "setError",
          e.response?.data?.detail || "Error al cargar ventas del libro IVA"
        );
        throw e;
      } finally {
        commit("setLoading", false);
      }
    },

    async fetchCompras({ commit }, periodo) {
      commit("setLoading", true);
      commit("setError", null);
      try {
        const res = await apiTamboUrl.get(
          `/libro-iva/compras?periodo=${periodo}`
        );
        commit("setCompras", res.data);
      } catch (e) {
        commit(
          "setError",
          e.response?.data?.detail || "Error al cargar compras del libro IVA"
        );
        throw e;
      } finally {
        commit("setLoading", false);
      }
    },

    async fetchSaldoTecnico({ commit }, periodo) {
      commit("setLoadingSaldo", true);
      commit("setError", null);
      try {
        const res = await apiTamboUrl.get(
          `/libro-iva/saldo?periodo=${periodo}`
        );
        commit("setSaldoTecnico", res.data);
      } catch (e) {
        commit(
          "setError",
          e.response?.data?.detail || "Error al cargar saldo fiscal"
        );
        throw e;
      } finally {
        commit("setLoadingSaldo", false);
      }
    },

    /**
     * Descarga un archivo TXT del CITI.
     * @param {string} periodo - Formato YYYY-MM
     * @param {string} tipo - 'ventas-cbtes' | 'compras-cbtes' | 'ventas-alicuotas' | 'compras-alicuotas'
     * @returns {Blob}
     */
    async exportarCITI(_, { periodo, tipo }) {
      const res = await apiTamboUrl.get(
        `/libro-iva/export/${tipo}?periodo=${periodo}`,
        {
          responseType: "blob",
        }
      );
      return res.data;
    },
  },
};
